import {
  CustomSuccessToast,
  CustomToast,
} from '@/@straico-ui/commons/CustomToasts';
import { toast } from 'react-hot-toast';

const useCopyHtmlFormat = ({ chatContainerRef }) => {
  const htmlToFormattedText = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const processElement = (element) => {
      let text = '';
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          text += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          switch (node.tagName) {
            case 'BR':
              text += '\n';
              break;
            case 'P':
            case 'DIV':
              text += processElement(node) + '\n\n';
              break;
            case 'SPAN':
            case 'B':
            case 'I':
            case 'U':
              text += processElement(node);
              break;
            case 'PRE':
              text += '\n' + node.textContent.trim() + '\n\n';
              break;
            default:
              text += processElement(node);
              break;
          }
        }
      });
      return text;
    };

    let formattedText = processElement(tempDiv);

    formattedText = formattedText.replace(/\n{3,}/g, '\n\n');

    return formattedText.trim();
  };

  const cleanStyleContent = (clonedContent) => {
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(clonedContent);

    // Remove style and script tags
    tempDiv.querySelectorAll('style, script').forEach((node) => node.remove());

    // Remove inline style attributes
    tempDiv.querySelectorAll('*').forEach((node) => {
      node.removeAttribute('style');
    });

    return tempDiv.innerHTML;
  };

  const handleCopyHtmlFormat = (e, selection) => {
    if (
      selection.rangeCount > 0 &&
      chatContainerRef.current.contains(selection.anchorNode)
    ) {
      e.preventDefault();

      const range = selection.getRangeAt(0);
      const clonedContent = range.cloneContents();

      // Clean the HTML content while preserving semantic tags
      const cleanHTML = cleanStyleContent(clonedContent);

      // Create a temporary container to extract plain text
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cleanHTML;

      const formattedText = htmlToFormattedText(tempDiv.innerHTML);

      e.clipboardData.setData('text/plain', formattedText);
      e.clipboardData.setData('text/html', cleanHTML);

      toast.custom(
        (t) => (
          <CustomToast
            id={t.id}
            message="Use the button to copy in Markdown format instead of highlighting the text."
          />
        ),
        { duration: 5000 }
      );

      toast.custom(
        (t) => (
          <CustomSuccessToast message="Copied to clipboard in HTML format" />
        ),
        { duration: 1500 }
      );
    }
  };

  return {
    handleCopyHtmlFormat,
  };
};

export default useCopyHtmlFormat;
